import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" fill=\"none\" id=\"icon-right\">\r\n                <path opacity=\"0.8\" d=\"M3.20312 8.32617L6.27771 11.4008L12.6417 5.0368\" stroke=\"#006FFF\" stroke-width=\"1.5\" />\r\n              </symbol>"
});
var result = sprite.add(symbol);
export default symbol